<template>
  <div class="salon-home">
    <div class="salon-menu">
      <!-- <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="menuChange"
      >
        <el-menu-item index="Home">沙龙预约</el-menu-item>
        <el-menu-item index="SalonList">我的预约</el-menu-item>
      </el-menu> -->
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="roomId"
          :options="meetingRoomsList"
          @change="getCalendar"
        />

      </van-dropdown-menu>
      <div
        class="salon-menu-my"
        @click="menuChange('SalonList')"
      >
        我的预约
      </div>
    </div>
    <div class="salon-home-main">
      <!-- <div class="salon-home-radio">
        <van-radio-group
          v-model="radio"
          direction="horizontal"
        >
          <van-radio name="1">新永一楼多功能厅</van-radio>
          <van-radio name="2">新永南三楼医美</van-radio>
          <van-radio name="3">新太三楼</van-radio>
        </van-radio-group>
      </div> -->
      <div>
        <van-calendar
          ref="calendar"
          title="预约日历"
          :poppable="false"
          :show-confirm="false"
          :max-date="endDate"
          :formatter="formatter"
          :default-date="null"
          @select="handleSelect"
        >
          <template
            slot="bottom-info"
            slot-scope="date"
          >{{ calendarDate[date.dateString] && 
          (calendarDate[date.dateString].count || "") }}</template>
        </van-calendar>
      </div>

    </div>
    <van-overlay
      :show="loadingShow"
      @click="loadingShow = false"
    >
      <div class="salon-loading">
        <van-loading />

      </div>
    </van-overlay>
  </div>
</template>

<script>
import meetingService from "@/apis/meeting/index.js";
import moment from "moment";
import getUserInfo from "@/models/userInfo";
import salonMixins from "./mixins/index.js";

export default {
  mixins: [salonMixins],

  data() {
    return {
      loadingShow: false,
      roomId: "2abd854eceb7b0413fd6e282de0cc857d25ff28f58d4c5ba",
      activeIndex: "Home",
      radio: "1",
      endDate: new Date(
        moment().add(1, "month").endOf("month").format("YYYY-MM-DD")
      ),
      calendarDate: {},
    };
  },
  async created() {
    const userInfo = await getUserInfo();
    this.JOB_SYNC_INFO();
    this.currentUserInfo = userInfo;
    this.getCalendar();
  },
  methods: {
    JOB_SYNC_INFO() {
      meetingService.JOB_SYNC_INFO();
    },
    getCalendar() {
      const params = {
        room_id: this.roomId,
        ding_user_id: this.currentUserInfo.ding_user_id,
        start_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment(this.endDate).format("YYYY-MM-DD"),
      };
      this.loadingShow = true;
      meetingService
        .getCalendar(params)
        .then((res) => {
          this.loadingShow = false;
          const calendarDate = {};
          res.forEach((item) => {
            calendarDate[item.date] = item;
          });
          this.calendarDate = calendarDate;
        })
        .catch(() => {
          this.loadingShow = false;
        });
    },

    menuChange(index) {
      console.log(index);
      if (index === "SalonList") {
        this.$router.push({
          name: "SalonList",
        });
      }
    },
    formatter(date) {
      const { calendarDate } = this;
      const dateString = moment(date.date).format("YYYY-MM-DD");
      date.dateString = dateString;
      if (calendarDate[dateString] && calendarDate[dateString].count > 0) {
        date.className = "salon-calendar-hasValue";
      }

      return date;
    },
    handleSelect(date) {
      console.log(date);
      this.$router.push({
        name: "SalonReservation",
        query: {
          date: moment(date).format("YYYY-MM-DD"),
          roomId: this.roomId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.salon-menu {
  display: flex;
  & > div {
    flex: 1;
  }
  .salon-menu-my {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }
}
.salon-home {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .van-calendar {
    // background-color: #eef1f9;
  }
  .van-calendar__bottom-info {
    color: #e7635e;
  }
}
.salon-home-radio {
  padding: 10px 20px;
}
.salon-home-main {
  flex: 1;
  background-color: #fff;
  overflow: scroll;
}
</style>
<style lang="scss">
.salon-home {
  .van-calendar__bottom-info {
    color: #e7635e;
    bottom: 3px;
    font-weight: 900;
  }
}
.salon-menu {
  .van-dropdown-menu__bar {
    box-shadow: none;
  }
}
.salon-calendar-hasValue {
  background-color: rgba(231, 99, 94, 0.3);
  border-radius: 50px;
  height: 55px;
}
.salon-loading {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>